import api from './axios';

/**
 * 获取所有省级地区
 */
export const getProvinces = () => {
  return api.get('/regions/provinces');
};

/**
 * 根据省级ID获取市级地区
 */
export const getCitiesByProvinceId = (provinceId) => {
  return api.get(`/regions/provinces/${provinceId}/cities`);
};

/**
 * 根据市级ID获取县级地区
 */
export const getDistrictsByCityId = (cityId) => {
  return api.get(`/regions/cities/${cityId}/districts`);
};

/**
 * 获取地区树形结构（省市县三级）
 */
export const getRegionTree = () => {
  return api.get('/regions/tree');
};

/**
 * 根据ID获取地区信息
 */
export const getRegionById = (id) => {
  return api.get(`/regions/${id}`);
};

/**
 * 根据名称模糊查询地区
 */
export const searchRegionsByName = (name) => {
  return api.get(`/regions/search?name=${name}`);
};

/**
 * 根据编码获取地区完整路径
 */
export const getRegionPathByCode = (code) => {
  return api.get(`/regions/path?code=${code}`);
}; 